import {
  Component,
  Inject,
  Injector,
  Input,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  SimpleChanges,
  Type,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Module } from 'projects/common/model/ModuleModel';
import { ScreenType } from 'projects/common/model/ScreenType';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { AbstractComponent } from '../abstract.component';
import {MediaPictureService} from "../../services/media-picture.service";
import { SliderProOptions } from '../slider-pro/slider-pro.component';
import { Device } from 'projects/common/model/Device';
import { UserRecentActivityCardComponent } from './user-recent-activity-card/user-recent-activity-card.component';
import { isPlatformBrowser } from '@angular/common';
import { UserRecentActivityCardV2Component } from './user-recent-activity-card-v2/user-recent-activity-card-v2.component';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { TranslateService } from '@ngx-translate/core';

declare var window: any;
export interface UserRecentActivityData {
  user_activities: UserActivity[];
}
export interface UserActivity {
  icon_name: string;
  picture: string;
  product_name: string;
  drivers: {
    level1: string[];
    level2: string[];
  };
  search_link: string;
  search_link_text: string;
  planner_link: string;
  title: string;
  destination_code: string;
  extra_info?: {
    rating?: string;
  };
}
@Component({
  selector: 'user-recent-activity',
  template: `
    <ng-container *ngIf="hasUserActivities()">
      <text *ngIf="module.pretitle || module.title || module.subtitle" [data]="module" class="-eva-3-mb-xlg" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></text>

      <slider-pro
        [options]="sliderProOptions"
        [componentParams]="componentParams"
        [components]="components"
        [upaData]="rawUpaData">
      </slider-pro>
    </ng-container>
  `,
  styleUrls: ['./user-recent-activity.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserRecentActivityComponent extends AbstractComponent implements OnInit, OnChanges {

  @ViewChild("content") content: any;
  private static MODULE_ID = 'UserRecentActivityModule';

  @Input() override module: Module<UserRecentActivityData>;
  @Input() device: Device;

  isMobile: boolean;
  isUserActivityV2Ab = false;
  sliderProOptions: SliderProOptions;
  components: Type<any>[] = [];
  componentParams: any[] = [];
  itemsPerRow = 1.3;

  rawUpaData: any;
  upaData: any;

  getModuleId(): string {
    return UserRecentActivityComponent.MODULE_ID;
  }

  hasUserActivities(): boolean {
    return !!(this.module?.data?.user_activities?.length);
  }

  constructor(injector: Injector,
              @Inject(PLATFORM_ID) private platformId: string,
              private mediaPictureService: MediaPictureService,
              landingModelService: LandingModelService,
              private translateService: TranslateService) {
    super(injector);

    this.isUserActivityV2Ab = landingModelService.getLandingModel().abTests?.ab.includes("NymeriaAboveTheFold|branch_test");
    if (this.isUserActivityV2Ab) this.itemsPerRow = 2; // TODO: Borrar condición cuando termine el AB
  }

  ngOnInit(): void {
    if (!this.module) {
      console.warn('UserRecentActivityComponent: Module is not available');
      return;
    }

    if (this.isUserActivityV2Ab) {
      this.module.title = { text: this.translateService.instant('userRecentActivity.titleV2Ab'), tag: 'H3' };
    }
    this.isMobile = this.screenType == ScreenType.MOBILE;
    this.rawUpaData = {uniqueId: this.module.unique_id, moduleId: this.module.id, moduleIndex: this.module.row_number, target: UpaTarget.USER_ACTIVITY};
    this.upaData = this.upaService.resolveData(this.rawUpaData);
    this.transformModelToSliderPro();
    this.initSliderProOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.module?.firstChange && changes?.module?.currentValue != null) {
      this.ngOnInit();
    }
  }

  getPicture(picture: string): string | undefined {
    const urlWithoutHttp = picture.startsWith("https:") ? picture.split("https:")[1] : picture;
    return this.mediaPictureService.getMediaUrl(urlWithoutHttp);
  }

  transformModelToSliderPro() {
    if (!this.hasUserActivities()) {
      console.warn('UserRecentActivityComponent: No se encontraron user_activities en module.data');
      this.components = [];
      this.componentParams = [];
      return;
    }
    const userComponent = this.isUserActivityV2Ab ? UserRecentActivityCardV2Component : UserRecentActivityCardComponent;
    this.components = [...new Array(this.module.data.user_activities.length).fill(userComponent)];
    this.componentParams = this.module.data.user_activities.map((activity: UserActivity, index: number) => {
      return {
        uniqueId: this.module.unique_id,
        rowPosition: index,
        iconName: activity.icon_name,
        picture: activity.picture,
        productName: activity.product_name,
        drivers: activity.drivers,
        searchLink: activity.search_link,
        searchLinkText: activity.search_link_text,
        plannerLink: activity.planner_link,
        title: activity.title,
        destinationCode: activity.destination_code,
        isMobile: this.isMobile,
        upaData: this.upaData,
        extraInfo: activity.extra_info
      }
    });
  }

  initSliderProOptions() {
    this.sliderProOptions = {
      itemsToShow: {'DEFAULT': this.screenType == 'DESKTOP'? (this.isUserActivityV2Ab ? 4 : 3) : this.itemsPerRow },
      itemsToMove: {'DEFAULT': 1 },
      fixedWidth: {'DEFAULT': this.isMobile? (this.isUserActivityV2Ab ? 212 : 324) : undefined },
      dragToMove: {'DEFAULT': this.screenType != 'DESKTOP'},
      showArrows: {'DEFAULT': this.screenType == 'DESKTOP'},
      showDots: {'DEFAULT': !this.isUserActivityV2Ab},
      dotsLighten: false,
      arrowsInnerContainer: false
    };
  }
}
